module.exports = __webpack_public_path__ + "static/media/combined-shape.5b753936.svg";